import { unitMapping } from '#src/lib/style.ts';

type Props = {
  size?: keyof typeof unitMapping;
  className?: string;
};

export const BaseballReliefPitcher = ({ size = 2, className }: Props) => (
  <svg
    className={className}
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.98338 6.26856L7.69746 7.93001L6.70832 8.77232L7.47335 10.6347H5.99737L5.28643 8.81869H4.39775L4.08092 10.6347H2.68994L3.61726 5.37988H7.25698L7.98338 6.26856ZM6.19057 7.58999L6.39921 7.41225L6.5074 6.78631L6.3683 6.61631H4.79186L4.62185 7.58999H6.19057ZM12.5776 5.37988L13.304 6.26856L12.9949 8.04592L11.9516 8.9346H9.7029L9.40152 10.6347H8.01055L8.93786 5.37988H12.5776ZM11.4957 7.69818L11.6966 7.52817L11.828 6.78631L11.6889 6.61631H10.1125L9.91928 7.69818H11.4957Z"
      fill="white"
    />
  </svg>
);
